"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonConfig = void 0;
var server_1 = __importDefault(require("react-dom/server"));
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@CommonFrontend/Public/Widgets/Button"));
var ButtonWidget_css_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Button/ButtonWidget.css");
var CommonWidgetRegistry_css_1 = require("../CommonWidgetRegistry.css");
exports.ButtonConfig = {
    publicRenderHtmlString: function (_a) {
        var token = _a.token, index = _a.index, attributes = _a.attributes, style = _a.style;
        return server_1.default.renderToString(react_1.default.createElement(Button_1.default, {
            attributes: attributes,
            text: token.text,
            href: token.href,
            index: index,
            style: style,
        }));
    },
    tokenType: {},
    type: "button",
    traits: {
        alignable: {
            defaultAlignment: "center",
        },
        spacingShim: {
            className: CommonWidgetRegistry_css_1.buttonWidgetSpacingShim,
        },
        selection: {
            ringMode: "hugging",
            ringBorderRadius: 4,
        },
        styleable: {
            styleKey: "button",
            properties: [
                {
                    type: "color",
                    path: "color",
                    label: "Button color",
                    defaultValue: {
                        themeIndex: 0,
                    },
                    variable: ButtonWidget_css_1.sharedButtonWidgetVars.backgroundColor,
                    presetColors: { type: "filteredThemeColors" },
                },
                {
                    type: "enumerable",
                    path: "size",
                    defaultValue: "medium",
                    label: "Button size",
                    options: [
                        {
                            label: "S",
                            value: "small",
                        },
                        {
                            label: "M",
                            value: "medium"
                        },
                        {
                            label: "L",
                            value: "large"
                        }
                    ]
                },
                {
                    type: "numerical",
                    path: "roundness",
                    defaultValue: 4,
                    label: "Roundness",
                    min: 0,
                    max: 50,
                    variable: ButtonWidget_css_1.sharedButtonWidgetVars.borderRadius,
                    withSlider: true,
                    suffix: "px"
                }
            ],
        },
    },
};
